import { client } from '@/common-utils/libraries/axios/axios';
import { PLANS } from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationUpdatePlan = (onSuccess, onError) => {
    return {
        mutationFn: ({ organizationId, planId, dataToSend }) => {
            return client.put(replaceParameters(PLANS.UPDATE.url,
                {
                    organizationId: organizationId,
                    planId: planId
                }
            ), dataToSend);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationUpdatePlan;